import { selectFromDriverDto } from '../../models';

export default selectFromDriverDto()
  .id
  .uuid
  .name
  .deleted
  .active
  .toString();
